import { render, staticRenderFns } from "./WorkRateSettingsTable.vue?vue&type=template&id=31797592&"
import script from "./WorkRateSettingsTable.vue?vue&type=script&lang=js&"
export * from "./WorkRateSettingsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports